import { render, staticRenderFns } from "./_how_to_list.vue?vue&type=template&id=153ddc26&v-if=fetch_data&"
import script from "./_how_to_list.vue?vue&type=script&lang=js&"
export * from "./_how_to_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports